import { Vue, Component, Prop } from 'vue-property-decorator';
import { VersionValidatorItem } from 'store';
import VersionValidator from './subcomponents/version-validator.vue';
import WithVersionValidator from '@/modules/versioning/components/with-version-validator/with-version-validator.vue';

@Component({
	components: {
		'version-validator': VersionValidator,
		'with-version-validator': WithVersionValidator
	}
})
export default class FeatureVersionValidator extends Vue {
	@Prop({
		default() {
			return {
				versionFrom: null,
				versionTo: null
			};
		}
	})
	versionInfo!: VersionValidatorItem;

	@Prop({
		default: false
	})
	isAvailable!: boolean;

	@Prop({
		default: 'div'
	})
	tag!: string;

	@Prop({
		default: true
	})
	showLabel!: boolean;
}
